interface DeviceHomePageData {
  [key: string]: string | number | undefined;
}

interface DeviceHomeUpdateData {
  id?: string | number;
  tabActive?: string;
  type?: string;
  org?: string | number;
  [key: string]: string | number | undefined;
}

interface DeviceHomeCreateData {
  orgId?: string | number;
}

interface DeviceHomeRoute {
  page: string;
  updatePage: string;
  createPage: string;
  getPage: (data?: DeviceHomePageData) => string;
  getUpdatePage: (data: DeviceHomeUpdateData) => string;
  getCreatePage: (data?: DeviceHomeCreateData) => string;
}

const _deviceHomeRoute: DeviceHomeRoute = {
  page: "/tracked_assets",
  updatePage: "/tracked_assets_update",
  createPage: "",
  getPage: (data) => {
    return `/tracked_assets`;
  },
  getUpdatePage: (data) => {
    const queryString = new URLSearchParams(
      data as Record<string, string>
    ).toString();
    return `/tracked_assets_update?${queryString}`;
  },
  getCreatePage: (data) => {
    if (data?.orgId) return `/tracked_assets_update?org=${data.orgId}`;
    return `/tracked_assets_update?`;
  },
};

export default _deviceHomeRoute;
